import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, TestTube, Home, MapPin, Calendar, Clock, CheckCircle2 } from 'lucide-react';
import { mockLabTests } from '../data/mockData';
export function LabBookingScreen() {
  const navigate = useNavigate();
  const [selectedTest, setSelectedTest] = useState<string | null>(null);
  const [collectionType, setCollectionType] = useState<'home' | 'lab'>('home');
  const [step, setStep] = useState<1 | 2 | 3>(1);
  const test = mockLabTests.find(t => t.id === selectedTest);
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="flex flex-col min-h-screen bg-slate-50" data-id="element-948">
      <div className="bg-white px-6 pt-12 pb-4 shadow-sm sticky top-0 z-10 flex items-center gap-3" data-id="element-949">
        <button onClick={() => step > 1 ? setStep(step - 1 as 1 | 2) : navigate(-1)} className="p-2 -ml-2 hover:bg-slate-50 rounded-full" data-id="element-950">
          <ArrowLeft className="w-6 h-6 text-slate-700" data-id="element-951" />
        </button>
        <h1 className="text-xl font-bold text-slate-900" data-id="element-952">Book Lab Test</h1>
      </div>

      <div className="p-6 flex-1 overflow-y-auto" data-id="element-953">
        {step === 1 && <div className="space-y-4" data-id="element-954">
            <h2 className="font-semibold text-slate-900 mb-2" data-id="element-955">Select a Test</h2>
            {mockLabTests.map(t => <div key={t.id} onClick={() => setSelectedTest(t.id)} className={`p-4 rounded-2xl border-2 cursor-pointer transition-colors ${selectedTest === t.id ? 'border-blue-600 bg-blue-50' : 'border-transparent bg-white shadow-sm'}`} data-id="element-956">
                <div className="flex items-start justify-between" data-id="element-957">
                  <div className="flex gap-3" data-id="element-958">
                    <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center shrink-0" data-id="element-959">
                      <TestTube className="w-5 h-5 text-blue-600" data-id="element-960" />
                    </div>
                    <div data-id="element-961">
                      <h3 className="font-semibold text-slate-900" data-id="element-962">{t.name}</h3>
                      <p className="text-sm text-slate-500 mt-1" data-id="element-963">
                        {t.description}
                      </p>
                    </div>
                  </div>
                  <span className="font-bold text-slate-900" data-id="element-964">
                    ₦{t.price.toLocaleString()}
                  </span>
                </div>
              </div>)}
          </div>}

        {step === 2 && test && <div className="space-y-6" data-id="element-965">
            <div className="bg-white p-4 rounded-2xl shadow-sm border border-slate-100" data-id="element-966">
              <h3 className="font-semibold text-slate-900 mb-1" data-id="element-967">{test.name}</h3>
              <p className="text-sm text-slate-500" data-id="element-968">
                ₦{test.price.toLocaleString()}
              </p>
            </div>

            <div data-id="element-969">
              <h3 className="font-semibold text-slate-900 mb-3" data-id="element-970">
                Collection Method
              </h3>
              <div className="grid grid-cols-2 gap-3" data-id="element-971">
                <button onClick={() => setCollectionType('home')} className={`p-4 rounded-xl border-2 flex flex-col items-center gap-2 transition-colors ${collectionType === 'home' ? 'border-blue-600 bg-blue-50 text-blue-700' : 'border-slate-100 bg-white text-slate-600'}`} data-id="element-972">
                  <Home className="w-6 h-6" data-id="element-973" />
                  <span className="text-sm font-medium" data-id="element-974">At Home</span>
                </button>
                <button onClick={() => setCollectionType('lab')} className={`p-4 rounded-xl border-2 flex flex-col items-center gap-2 transition-colors ${collectionType === 'lab' ? 'border-blue-600 bg-blue-50 text-blue-700' : 'border-slate-100 bg-white text-slate-600'}`} data-id="element-975">
                  <MapPin className="w-6 h-6" data-id="element-976" />
                  <span className="text-sm font-medium" data-id="element-977">Visit Lab</span>
                </button>
              </div>
            </div>

            <div data-id="element-978">
              <h3 className="font-semibold text-slate-900 mb-3" data-id="element-979">Date & Time</h3>
              <div className="grid grid-cols-2 gap-3 mb-3" data-id="element-980">
                <div className="bg-white p-3 rounded-xl border border-slate-200 flex items-center gap-2" data-id="element-981">
                  <Calendar className="w-5 h-5 text-slate-400" data-id="element-982" />
                  <span className="text-sm text-slate-700" data-id="element-983">Today</span>
                </div>
                <div className="bg-white p-3 rounded-xl border border-slate-200 flex items-center gap-2" data-id="element-984">
                  <Clock className="w-5 h-5 text-slate-400" data-id="element-985" />
                  <span className="text-sm text-slate-700" data-id="element-986">2:00 PM</span>
                </div>
              </div>
            </div>

            {collectionType === 'home' && <div data-id="element-987">
                <h3 className="font-semibold text-slate-900 mb-3" data-id="element-988">Address</h3>
                <textarea className="w-full bg-white border border-slate-200 rounded-xl p-3 text-sm focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600" rows={3} placeholder="Enter your full address..." defaultValue="12 Admiralty Way, Lekki Phase 1, Lagos" data-id="element-989" />
              </div>}
          </div>}

        {step === 3 && <div className="flex flex-col items-center justify-center h-full text-center py-12" data-id="element-990">
            <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-991">
              <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-992" />
            </motion.div>
            <h2 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-993">
              Booking Confirmed!
            </h2>
            <p className="text-slate-500 mb-8 max-w-[250px]" data-id="element-994">
              Your {test?.name} has been scheduled successfully.
            </p>
            <div className="bg-white w-full p-4 rounded-2xl shadow-sm border border-slate-100 mb-8 text-left" data-id="element-995">
              <div className="flex justify-between mb-2" data-id="element-996">
                <span className="text-slate-500" data-id="element-997">Date</span>
                <span className="font-medium text-slate-900" data-id="element-998">
                  Today, 2:00 PM
                </span>
              </div>
              <div className="flex justify-between mb-2" data-id="element-999">
                <span className="text-slate-500" data-id="element-1000">Method</span>
                <span className="font-medium text-slate-900" data-id="element-1001">
                  {collectionType === 'home' ? 'Home Collection' : 'Lab Visit'}
                </span>
              </div>
              <div className="flex justify-between pt-2 border-t border-slate-100" data-id="element-1002">
                <span className="text-slate-500" data-id="element-1003">Total Paid</span>
                <span className="font-bold text-slate-900" data-id="element-1004">
                  ₦{test?.price.toLocaleString()}
                </span>
              </div>
            </div>
          </div>}
      </div>

      <div className="p-6 bg-white border-t border-slate-100" data-id="element-1005">
        {step === 1 ? <button onClick={() => setStep(2)} disabled={!selectedTest} className="w-full bg-blue-600 text-white py-3.5 rounded-xl font-semibold text-lg shadow-sm hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1006">
            Continue
          </button> : step === 2 ? <button onClick={() => setStep(3)} className="w-full bg-blue-600 text-white py-3.5 rounded-xl font-semibold text-lg shadow-sm hover:bg-blue-700 transition-colors" data-id="element-1007">
            Pay ₦{test?.price.toLocaleString()}
          </button> : <button onClick={() => navigate('/home')} className="w-full bg-blue-600 text-white py-3.5 rounded-xl font-semibold text-lg shadow-sm hover:bg-blue-700 transition-colors" data-id="element-1008">
            Back to Home
          </button>}
      </div>
    </motion.div>;
}